// extracted by mini-css-extract-plugin
export var fullWidth = "media-module--full-width--1c135";
export var img = "media-module--img--7e51e";
export var media = "media-module--media--3e18b";
export var mediaVideo = "media-module--mediaVideo--6a19f";